import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";

class Servise_se {
    constructor() {
        this.entity = 'templateSmsManager';
    }

    delete(id) {
        return Api.delete(this.entity,id)}


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return Api.new_(this.entity)
        }
    }

    getPage(page_,size_,filter) {
        let formData = new FormData();
        formData.set("page", page_)
        formData.set("size", size_)
        formData.set("filter", filter)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/' + this.entity + '/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    save(model) {
        return Api.save(this.entity,model)
    }


     download(){
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+this.entity+'/download',
            headers: {'Content-Type': 'application/json'},
            responseType: 'blob', // important
        })


}

}
export default new Servise_se();

